import { render, staticRenderFns } from "./row-mail-queue.vue?vue&type=template&id=54c4fe98&scoped=true&"
import script from "./row-mail-queue.vue?vue&type=script&lang=js&"
export * from "./row-mail-queue.vue?vue&type=script&lang=js&"
import style0 from "./row-mail-queue.vue?vue&type=style&index=0&id=54c4fe98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c4fe98",
  null
  
)

export default component.exports